// extracted by mini-css-extract-plugin
export default {"label":"DatosLegal_label__i8dHJ","title":"DatosLegal_title__gXN1l","info":"DatosLegal_info__+r+PU","code":"DatosLegal_code__eGWGz","button":"DatosLegal_button__v6R3A"};